import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
  VStack,
} from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import usePartyId from '../../../../../common/src/hooks/query-params/usePartyId';
import { useUpdatePartyForCompanyData } from '../../api/updatePartyForCompanyData';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onFinish: () => void;
}

const NeedsEnrichmentModal: React.FC<React.PropsWithChildren<Props>> = ({
  isOpen,
  onClose,
  onFinish,
}) => {
  const { t } = useTranslation();
  const partyId = usePartyId();

  const { mutateAsync: updatePartyForCompanyData, isLoading } =
    useUpdatePartyForCompanyData();

  const handleOnClickYes = async () => {
    if (partyId) await updatePartyForCompanyData(partyId);
    closeModal();
  };

  const closeModal = () => {
    onFinish();
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          {t('COMPANY-SCAN_INTRO_NEEDS-ENRICHMENT_TITLE')}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody as={VStack} spacing="4">
          <Text>{t('COMPANY-SCAN_INTRO_NEEDS-ENRICHMENT_DESCRIPTION')}</Text>
        </ModalBody>

        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={closeModal}>
            {t('SKIP')}
          </Button>
          <Button
            variant="primary"
            onClick={handleOnClickYes}
            isLoading={isLoading}
          >
            {t('OVERWRITE')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default NeedsEnrichmentModal;
